"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TROLMASTER_DEVICE_TYPES = exports.SONOFF_DEVICE_TYPES = exports.DEVICE_TYPES_BY_FAMILY = exports.DEVICE_SYNC_INTERVAL_MS = exports.DEVICE_FAMILY_LABELS = exports.DEVICE_FAMILIES = void 0;
// Matches the Firebase cron that syncs device readings and online status every 5 minutes.
var DEVICE_SYNC_INTERVAL_MS = 5 * 60 * 1000;
exports.DEVICE_SYNC_INTERVAL_MS = DEVICE_SYNC_INTERVAL_MS;
var DEVICE_FAMILIES = ["TROLMASTER", "DIGITALTWIN", "SONOFF"];
exports.DEVICE_FAMILIES = DEVICE_FAMILIES;
// The API stores/sends "DIGITALTWIN" (no space); this is display-only formatting.
var DEVICE_FAMILY_LABELS = {
    TROLMASTER: "TROLMASTER",
    DIGITALTWIN: "DIGITAL TWIN",
    SONOFF: "SONOFF",
};
exports.DEVICE_FAMILY_LABELS = DEVICE_FAMILY_LABELS;
var TROLMASTER_DEVICE_TYPES = ["AQUAX", "HYDROX", "HYDROXPLUS"];
exports.TROLMASTER_DEVICE_TYPES = TROLMASTER_DEVICE_TYPES;
var SONOFF_DEVICE_TYPES = ["POW", "TH", "SWITCH"];
exports.SONOFF_DEVICE_TYPES = SONOFF_DEVICE_TYPES;
var DEVICE_TYPES_BY_FAMILY = {
    TROLMASTER: TROLMASTER_DEVICE_TYPES,
    DIGITALTWIN: [],
    SONOFF: SONOFF_DEVICE_TYPES,
};
exports.DEVICE_TYPES_BY_FAMILY = DEVICE_TYPES_BY_FAMILY;
